import React from "react"

function Work () {
    return (
        <div>
          <h1 className="experience-heading">Work Experience</h1>
          <div className="experience-container">

            <div className="experience-card">
              <h2 className="experience-title">Software Developer @ BMO</h2>
              <div className="pro-details">
                <p>
                  •	Developed Spring boot REST APIs to deliver new user functionalities for banking applications in sprint development cycles and deployed with AWS using CI/CD pipelines.</p>
                <p>•	Contributed to frontend feature development using Angular, JavaScript, TypeScript, HTML, and CSS, collaborating with the UI team to integrate backend endpoints into existing web interfaces.</p>
                <p>•	Increased test reliability to 90% coverage across all services in a project by designing and implementing unit tests with Junit and Mockito, catching regressions before release.</p>
                <p>•	Accelerated feature delivery and code review cycles using GitHub Copilot for boilerplate generation and test scaffolding, integrated into daily Spring Boot development within sprint workflows. </p>
                <div className="details">
                </div>
              </div>
            </div>

            <div className="experience-card">
              <h2 className="experience-title">QA Analyst @ Equitable Bank</h2>
              <div className="pro-details">
                <p>
                  • Created test cases, and groovy scripts to test functionality of APIs from the online banking applications using SOAPUI and ReadyAPI and maintained 80% test coverage.</p>
                <p>• Developed and ran daily scheduled tests for the backend APIs on multiple testing environments and report bugs/error to DevOps.</p>
                <p>• Developed, executed and reported performance tests using Apache JMeter for API calls.</p>
                <p>• Collaborated with performance team and DevOps to identify and resolve performance issues in test reports. </p>
                <div className="details">
                </div>
              </div>
            </div>
          </div>
        </div>
      );
};

export default Work;
